export enum AnswerType {
  Textarea = 'textarea',
  Select = 'select',
  Radio = 'radio',
  Info = 'info',
  Upload = 'upload',
}
